<template>
  <div class="p-3 pb-5 mb-5">
    <div class="row">
      <div class="col">
        <h5>Select Assignment</h5>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <v-select :options="forms" label="name" v-model="selectedForm"></v-select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-button block variant="orange" @click="saveForm">Update Assignment</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnitAssignmentSelectionModal',
  data () {
    return {
      selectedForm: this.form
    };
  },
  computed: {
    forms () {
      return this.$store.state.assignments;
    }
  },
  methods: {
    saveForm () {
      this.$emit('input', this.selectedForm.id);
      this.$emit('update:form', this.selectedForm);
      this.$modal.hide('assignment-modal-' + this.sectionId)
    }
  },
  props: ['value', 'form', 'sectionId']
};
</script>

<style scoped>

</style>